<p-carousel
  [(value)]="slides"
  [numVisible]="1"
  [numScroll]="1"
  [circular]="true"
  [responsiveOptions]="responsiveOptions"
  autoplayInterval="5000"
  [showNavigators]="false">
  <ng-template pTemplate="item" let-slide>
    <a *ngIf="slide.targetUrl && slide.targetUrl.startsWith('/'); else externalSlide"
       [routerLink]="slide.targetUrl">
      <img *ngIf='slide.mediaType == "image"' [src]="slide.bannerUrl" [title]="slide?.title" class="w-100" alt=""/>
    </a>
    <ng-template #externalSlide>
      <a [href]="slide.targetUrl ? slide.targetUrl : 'javascript:void(0)'">
        <img *ngIf='slide.mediaType == "image"' [src]="slide.bannerUrl" [title]="slide?.title" class="w-100" alt=""/>
      </a>
    </ng-template>
  </ng-template>
</p-carousel>
